import { useMutation, useQueryClient } from "@tanstack/react-query";
import { changeLeaveStatus } from "src/redux/api/_hr_attendance.api";
import { leaveKeys } from "./useLeaves";
import { toast } from "react-toastify";
import { leaveByIdKeys } from "../../Attendance/hooks/useLeavesById";
import { leaveDateKeys } from "../../Attendance/hooks/useLeaveDays";
import { leaveBalanceKeys } from "./useLeaveBalance";

export const useLeaveMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      id,
      status,
      reason,
    }: {
      id: string;
      status: "APPROVED" | "REJECTED";
      reason: string;
    }) => changeLeaveStatus(id, status, reason),

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: leaveKeys.all,
      });

      queryClient.invalidateQueries({
        queryKey: leaveByIdKeys.all,
      });

      queryClient.invalidateQueries({
        queryKey: leaveBalanceKeys.all,
      });

      queryClient.invalidateQueries({
        queryKey: leaveDateKeys.all,
      });

      toast.success("Request Responded!");
    },

    onError: (error) => {
      console.error(error, 'leave mutaion error');
      toast.error("Failed to Update Status");
    }
  });
};
